<div class="portal-list__container">
  @for (credential of credentials(); track credential.id) {
    <app-portal-credential
      [credential]="credential"
      [config]="getConfig(credential)"
      [selected]="isSelected(credential)"
      [disabled]="disabled() || forceDisabled()"
      [selectable]="allowSelect()"
      [removable]="allowRemove()"
      [deselectable]="!exists(credential)"
      (togglePortal)="onToggle($event)"
      (remove)="onRemovePortal($event)"
    >
    </app-portal-credential>
  }
</div>
@if (allowAdd()) {
  <div class="portal-list__add-button">
    <button
      im-button
      class="inverted"
      [disabled]="disabled()"
      (click)="onAddPortal()"
    >
      <i iconStart class="icon icon--plus me-2"></i>
      {{ 'ADD_PORTAL_A' | translate }}
    </button>
  </div>
}
